module.exports = __webpack_public_path__ + "img/头部背景.3a9e6920.png";